<div class="row">
  <div class="col-md-12 text-center">
    <h1 class="title">LOGIN</h1>
  </div>
</div>
<div class="row">
  <div class="col-md-6 offset-md-3 text-center subtitle">Please enter your user name and password.</div>
</div>
<div class="row">
  <div class="col-md-4 offset-md-4">
    <div class="card">
      <div class="card-body">
        <h2>Account Information</h2>
        <div class="col-md-10">
          <form class="form-horizontal login" name="loginForm" #f="ngForm" novalidate
                (ngSubmit)="f.form.valid ? login() :
                          (!email.valid && showErrorAlert('Email is required', 'Please enter a valid email'));
                          (!password.valid && showErrorAlert('Password is required', 'Please enter a valid password'))">
            <div class="form-group">
              <label for="inputEmail">User Name:</label>
              <input type="email" name="email" class="form-control" id="inputEmail" aria-describedby="inputEmail"
                    placeholder="User Name" [(ngModel)]="userLogin.email" #email="ngModel" required>
              <span class="errorMessage" *ngIf="f.submitted && !email.valid">
                *Email is required!
              </span>
            </div>
            <div class="form-group">
              <label for="inputPassword">Password:</label>
              <input type="password" name="password" class="form-control" id="inputPassword"
                    placeholder="Password" [(ngModel)]="userLogin.password" #password="ngModel" required>
              <span class="errorMessage" *ngIf="f.submitted && !password.valid">
                Password is required
              </span>
            </div>
            <button type="submit" class="btn btn-primary">Log In</button>
          </form>
        </div>
        <!--<div class="row">
          <div class="col-md-6 offset-md-6 text-right">
            <button type="button" [routerLink]='["/account/create"]' class="btn btn-link">New user?</button>
          </div>
        </div>-->
        <div class="row">
          <div class="col-md-6 offset-md-6 text-right">
            <button type="button" [routerLink]='["/account/reset"]' class="btn btn-link">Forgot your password?</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<br />
<br />
<div class="row">
  <div class="col-md-6 offset-md-3 col-10 offset-1 text-center subtitle">You are accessing a U.S. Government information system. System usage may be monitored, recorded, and subject to audit. Unauthorized use of the system is prohibited and subject to criminal and civil penalties. Use of the system indicates consent to monitoring and recording.</div>
</div>
